import React from "react";
import Button from "../ui/Button";

const FormActions = ({
  isLoading = false,
  onCancel,
  loadingText = "Saving...",
  saveText = "Save",
  cancelText = "Cancel",
  saveClass = "btn btn-md btn-primary",
  cancelClass = "btn btn-md btn-cancel",
}) => {
  return (
    <div className="action-container">
      <Button
        type="button"
        className={cancelClass}
        onClick={onCancel}
        disabled={isLoading}
      >
        {cancelText}
      </Button>

      <Button type="submit" className={saveClass} disabled={isLoading}>
        {isLoading ? loadingText : saveText}
      </Button>
    </div>
  );
};

export default FormActions;
